export default __webpack_public_path__ + "static/media/regulatory--in-street-pedestrian-crossing--g1.e30c31dd.png";